import React from 'react';
import { faMessages } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function MessagesDuotoneIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faMessages} {...props} />;
}
